import React from 'react';
import {
  FaWhatsapp,
  FaMapMarkerAlt,
  FaClock,
  FaEnvelope,
  FaIndustry,
  FaHandshake
} from 'react-icons/fa';
import { motion } from 'framer-motion';

export default function ContatoPage() {
  // ===== CONTATOS =====
  const vendasPhone = '(19) 99631-8018';
  const vendasWhatsapp = '5519996318018';
  const vendasLink = `https://wa.me/${vendasWhatsapp}?text=${encodeURIComponent(
    'Olá Usina Rosa, gostaria de informações comerciais e de vendas.'
  )}`;

  const comprasPhone = '(15) 99170-6314';
  const comprasWhatsapp = '5515991706314';
  const comprasLink = `https://wa.me/${comprasWhatsapp}?text=${encodeURIComponent(
    'Olá Usina Rosa, gostaria de tratar assuntos relacionados a compras.'
  )}`;

  const endereco = 'Rod. Castelo Branco, Km 111 — Pinhal, Boituva - SP';
  const email = 'comercial@rosaindustria.com';

  const fade = {
    hidden: { opacity: 0, y: 24 },
    show: (i = 0) => ({
      opacity: 1,
      y: 0,
      transition: { delay: 0.12 * i, duration: 0.6, ease: 'easeOut' }
    })
  };

  return (
    <main className="relative min-h-screen overflow-hidden">
      {/* ================= BACKGROUND ================= */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-white via-emerald-50 to-white" />
        <div
          className="absolute inset-0"
          style={{
            background:
              'radial-gradient(800px 400px at 15% 10%, rgba(16,185,129,0.18), transparent 60%),' +
              'radial-gradient(700px 350px at 85% 20%, rgba(14,165,233,0.14), transparent 60%),' +
              'radial-gradient(900px 500px at 50% 80%, rgba(5,150,105,0.12), transparent 65%)'
          }}
        />
      </div>

      {/* ================= HERO ================= */}
      <header className="relative pt-32 pb-40 px-6 text-center">
        <motion.h1
          variants={fade}
          initial="hidden"
          animate="show"
          className="text-4xl md:text-6xl font-extrabold text-emerald-900"
        >
          Contato
        </motion.h1>

        <motion.p
          custom={1}
          variants={fade}
          initial="hidden"
          animate="show"
          className="mt-6 max-w-3xl mx-auto text-lg md:text-xl text-slate-600"
        >
          Canais organizados para garantir agilidade, clareza e eficiência no atendimento.
        </motion.p>

        <svg
          className="absolute bottom-0 left-0 w-full h-28"
          viewBox="0 0 1440 120"
          preserveAspectRatio="none"
        >
          <path
            fill="white"
            d="M0,64L80,80C160,96,320,128,480,117C640,107,800,53,960,48C1120,43,1280,85,1360,106L1440,128L1440,0L0,0Z"
          />
        </svg>
      </header>

      {/* ================= CONTEÚDO ================= */}
      <section className="relative bg-white px-6 pb-28">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* VENDAS */}
            <motion.div
              custom={2}
              variants={fade}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="rounded-3xl border border-emerald-200 bg-gradient-to-br from-white to-emerald-50 p-10 shadow-xl"
            >
              <div className="flex items-start gap-5">
                <div className="bg-emerald-600 text-white p-4 rounded-2xl">
                  <FaIndustry className="text-2xl" />
                </div>
                <div>
                  <h2 className="text-3xl font-bold text-emerald-900">
                    Comercial / Vendas
                  </h2>
                  <p className="mt-2 text-slate-600">
                    Atendimento exclusivo para negociações comerciais.
                  </p>
                </div>
              </div>

              <ul className="mt-8 space-y-2 text-slate-700">
                <li>• Compra de produtos</li>
                <li>• Preços, volumes e contratos</li>
                <li>• Logística e condições comerciais</li>
              </ul>

              <div className="mt-8 text-lg font-semibold text-slate-800">
                📞 {vendasPhone}
              </div>

              <a
                href={vendasLink}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex w-full items-center justify-center gap-3 rounded-xl bg-emerald-600 px-8 py-4 text-lg font-bold text-white hover:bg-emerald-700 transition"
              >
                <FaWhatsapp />
                Falar com Vendas
              </a>
            </motion.div>

            {/* COMPRAS */}
            <motion.div
              custom={3}
              variants={fade}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="rounded-3xl border border-sky-200 bg-gradient-to-br from-white to-sky-50 p-10 shadow-xl"
            >
              <div className="flex items-start gap-5">
                <div className="bg-sky-600 text-white p-4 rounded-2xl">
                  <FaHandshake className="text-2xl" />
                </div>
                <div>
                  <h2 className="text-3xl font-bold text-sky-900">Compras</h2>
                  <p className="mt-2 text-slate-600">
                    Canal dedicado a fornecedores e propostas.
                  </p>
                </div>
              </div>

              <ul className="mt-8 space-y-2 text-slate-700">
                <li>• Insumos e matéria-prima</li>
                <li>• Equipamentos e manutenção</li>
                <li>• Prestadores de serviço</li>
              </ul>

              <div className="mt-8 text-lg font-semibold text-slate-800">
                📞 {comprasPhone}
              </div>

              <a
                href={comprasLink}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex w-full items-center justify-center gap-3 rounded-xl bg-sky-600 px-8 py-4 text-lg font-bold text-white hover:bg-sky-700 transition"
              >
                <FaWhatsapp />
                Falar com Compras
              </a>
            </motion.div>
          </div>

          {/* INFORMAÇÕES INSTITUCIONAIS */}
          <div className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-6">
            <InfoCard icon={<FaMapMarkerAlt />} title="Endereço" text={endereco} />

            <InfoCard
              icon={<FaClock />}
              title="Atendimento"
              text="Seg–Sex: 8h às 18h | Sáb: 8h às 12h"
            />

            {/* ✅ EMAIL AJUSTADO */}
            <InfoCard
              icon={<FaEnvelope />}
              title="E-mail"
              text={
                <>
                  <p className="font-medium text-slate-800 break-all">
                    {email}
                  </p>
                  <p className="mt-2 text-sm text-slate-600">
                    Canal destinado a <strong>demais assuntos</strong>.
                  </p>
                </>
              }
            />
          </div>
        </div>
      </section>
    </main>
  );
}

function InfoCard({ icon, title, text }) {
  return (
    <div className="rounded-2xl border bg-white p-6 shadow-sm flex items-start gap-4">
      <div className="text-emerald-600 text-2xl">{icon}</div>
      <div>
        <h3 className="font-semibold text-emerald-900">{title}</h3>
        <div className="text-slate-600">{text}</div>
      </div>
    </div>
  );
}